export default {
  title: "SORU5",
  text: `1950'li yılların başında istasyon, bir mola yeri olmaktan ziyade hayatın aktığı yerdi bizim kasabada. Kasabanın gençleri istasyonda buluşur, kalabalıkta kendilerini unuttururdu. Filmlerdeki gibi, gençler ilk kez burada göz göze gelirdi. İlk ayrılık burada yaşanır, askerlik veya çalışmak için büyük şehre gidenlerin ardından gözyaşı ilk kez burada dökülürdü. Ayrılığın acısı kadar buluşmanın sevinci de istasyondu. Ben de tezkere alıp gelen ağabeyimi burada beklemiştim. İki gün boyunca istasyona her gelen trende gözlerim ağabeyimi aramıştı. Nihayet ağabeyim trenden indiğinde boynuna sarılmış, dakikalarca ağlamıştım.`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/5.js